import { CLASSIC_LIQUIDITY_TABS } from "@/domains/liquidity-page/constants"
import { ComplexBreadcrumbDropdown } from "@/domains/navigation/components/complex-breadcrumb-dropdown"
import { ComplexBreadcrumbItem } from "@/domains/navigation/types/complex-breadcrumb-item"

export const ClassicLiquidityPagesComplexBreadcrumbApplication: ComplexBreadcrumbItem = {
  type: "complex",
  application: "classic-liquidity-pages",
  render: () => <ClassicLiquidityPagesComplexBreadcrumbApplicationComponent />,
}

export const ClassicLiquidityPagesComplexBreadcrumbApplicationComponent = () => {
  return (
    <ComplexBreadcrumbDropdown
      tabs={CLASSIC_LIQUIDITY_TABS}
      navigationMode="slug"
      invalidTabMessage="Invalid classic liquidity tab"
    />
  )
}
